import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const LogoGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('white', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M17.5006 7.98485V10.2415H13.3144C13.8177 11.1514 14.4179 11.9882 14.7729 12.9176C16.3325 17.0049 14.02 21.5353 9.78422 22.7873C8.79305 23.0884 7.7507 23.1831 6.72149 23.0657C5.69229 22.9483 4.69807 22.6212 3.8002 22.1046C2.90232 21.588 2.11986 20.8928 1.50108 20.062C0.882312 19.2313 0.440367 18.2825 0.202526 17.2743C-0.0353153 16.2661 -0.0640055 15.2198 0.118226 14.2001C0.300458 13.1804 0.689744 12.2088 1.26206 11.3454C1.83437 10.4819 2.57757 9.74497 3.44578 9.17994C4.31399 8.6149 5.28879 8.23379 6.31002 8.06014C6.66168 7.99823 7.01781 7.96514 7.37487 7.96118C10.6089 7.96118 13.8414 7.96118 17.0725 7.96118C17.1994 7.96118 17.3178 7.97194 17.5006 7.98485ZM7.61795 10.2651C6.22242 10.2677 4.88507 10.8245 3.90009 11.8131C2.91512 12.8017 2.36321 14.1411 2.36577 15.5367C2.36834 16.9322 2.92518 18.2696 3.91378 19.2545C4.90239 20.2395 6.24178 20.7914 7.63731 20.7888C8.32831 20.7876 9.01229 20.6502 9.6502 20.3846C10.2881 20.119 10.8675 19.7303 11.3552 19.2408C11.8429 18.7513 12.2294 18.1706 12.4927 17.5317C12.7559 16.8928 12.8908 16.2083 12.8895 15.5173C12.8882 14.8263 12.7509 14.1423 12.4853 13.5044C12.2196 12.8665 11.831 12.2872 11.3415 11.7994C10.852 11.3117 10.2712 10.9252 9.63232 10.662C8.99343 10.3987 8.30895 10.2639 7.61795 10.2651Z"
        fill={fillColor}
      />
      <path
        d="M26.4 7.93321V10.2006H18.404C18.404 9.49069 18.3868 8.80015 18.4191 8.11391C18.4191 7.97839 18.6062 7.82565 18.7396 7.72885C19.8152 6.94581 20.9295 6.18858 22.003 5.39048C22.4514 5.0643 22.8606 4.6875 23.2227 4.26755C23.3992 4.08464 23.506 3.84562 23.5245 3.59209C23.543 3.33857 23.472 3.08659 23.3238 2.88002C23.1704 2.67745 22.952 2.53377 22.7053 2.47306C22.4585 2.41235 22.1984 2.43831 21.9686 2.54658C21.3899 2.83054 20.8929 3.26079 20.2799 3.67167L18.518 2.2153C19.7421 0.0985078 22.9387 -0.665172 24.9609 0.647066C25.332 0.897325 25.6461 1.22306 25.8827 1.60299C26.1193 1.98292 26.273 2.40849 26.3339 2.8519C26.3949 3.29532 26.3615 3.74659 26.2361 4.17625C26.1107 4.6059 25.8961 5.00426 25.6062 5.34531C25.1053 5.87685 24.5541 6.3588 23.9606 6.78447C23.4895 7.15663 22.9775 7.47931 22.4999 7.92676L26.4 7.93321Z"
        fill={fillColor}
      />
    </g>
  );
};

export const LogoSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <LogoGroup {...props} />
    </svg>
  );
};
